// eslint-disable-next-line import/prefer-default-export
export const classNames = (...classes) => classes.filter(Boolean).join(' ');
